{
  "sessionsCount_one": "{{count}} sesión",
  "sessionsCount_zero": "{{count}} sesiones",
  "sessionsCount_other": "{{count}} sesiones",
  "viewersCount_one": "{{count}} alumno",
  "viewersCount_zero": "{{count}} alumnos",
  "viewersCount_other": "{{count}} alumnos",
  "title": "Videos",
  "subtitle": "Sube, organiza y sigue los videos de las clases. Se entregan por streaming protegido, solo dentro del área de miembros.",
  "loading": "Cargando videos...",
  "loadError": "No se pudieron cargar los videos.",
  "empty": "Todavía no hay videos.",
  "notFound": "Video no encontrado.",
  "back": "Volver a videos",
  "openStudio": "Abrir en el estudio",
  "failedReason": "Error en el procesamiento: {{reason}}",
  "pagination": {
    "label": "Paginación",
    "previous": "Anterior",
    "next": "Siguiente",
    "status": "Página {{page}} de {{total}}"
  },
  "status": {
    "UPLOADING": "Esperando subida",
    "PROCESSING": "Procesando",
    "READY": "Listo",
    "FAILED": "Falló"
  },
  "visibility": {
    "PRIVATE": "Privado",
    "SHAREABLE": "Compartible",
    "PUBLIC": "Público"
  },
  "visibilityHint": {
    "PRIVATE": "Solo los alumnos con acceso a la clase lo ven, dentro del área de miembros.",
    "SHAREABLE": "Reservado para enlaces compartidos (próximamente). Por ahora funciona como Privado.",
    "PUBLIC": "Cualquiera lo ve sin iniciar sesión, pero solo en los dominios de tu área de miembros."
  },
  "upload": {
    "cta": "Haz clic o arrastra un video para subirlo",
    "hint": "Streaming protegido hasta 4K · máx. 20 GB",
    "sending": "Subiendo video...",
    "done": "Video subido. El procesamiento empieza en unos instantes.",
    "error": "No se pudo subir el video.",
    "unsupported": "Archivo no compatible. Sube un archivo de video.",
    "tooLarge": "Video demasiado grande ({{size}}). Máximo: 20 GB."
  },
  "delete": {
    "button": "Eliminar video",
    "title": "¿Eliminar video?",
    "description": "Las clases que usan este video dejarán de reproducirlo. Esta acción no se puede deshacer.",
    "confirm": "Eliminar"
  },
  "toasts": {
    "deleted": "Video eliminado",
    "error": "No se pudo completar la acción.",
    "saved": "Cambios guardados",
    "thumbnailUpdated": "Miniatura actualizada",
    "subtitleSaved": "Subtítulo guardado",
    "subtitleRemoved": "Subtítulo eliminado"
  },
  "details": {
    "title": "Detalles",
    "name": "Título",
    "description": "Descripción",
    "visibility": "Visibilidad",
    "save": "Guardar",
    "watermarkText": "Texto de la marca de agua",
    "watermarkHint": "Se muestra sobre el video en el reproductor. El cambio se aplica en la próxima reproducción, sin reprocesar el video.",
    "watermarkCustom": "Texto personalizado",
    "watermarkPosition": "Posición de la marca de agua"
  },
  "thumbnails": {
    "title": "Miniatura",
    "description": "Elige una sugerencia, captura el fotograma pausado en el reproductor o sube una imagen.",
    "candidate": "Usar sugerencia {{index}}",
    "custom": "Miniatura actual",
    "useFrame": "Usar fotograma en {{time}}",
    "upload": "Subir imagen",
    "frameHint": "Reproduce y pausa en el punto deseado para capturar el fotograma."
  },
  "subtitles": {
    "title": "Subtítulos",
    "description": "Sube archivos SRT o WebVTT. Un subtítulo por idioma.",
    "empty": "No hay subtítulos.",
    "remove": "Eliminar subtítulo {{label}}",
    "removeConfirm": "¿Eliminar el subtítulo \"{{label}}\"?",
    "lang": "Idioma",
    "label": "Nombre mostrado",
    "chooseFile": "Elegir archivo",
    "noFile": "Ningún archivo seleccionado",
    "add": "Guardar subtítulo",
    "invalidFile": "Archivo de subtítulos no válido.",
    "replaceWarning": "Ya existe un subtítulo en {{language}}. Se reemplazará al guardar.",
    "replace": "Reemplazar subtítulo"
  },
  "analytics": {
    "title": "Audiencia",
    "viewers": "Alumnos",
    "sessionsHint_one": "{{count}} sesión",
    "sessionsHint_zero": "{{count}} sesiones",
    "sessionsHint_other": "{{count}} sesiones",
    "watchedHours": "Tiempo visto",
    "avgCoverage": "Promedio visto",
    "completed": "Completaron",
    "completedHint": "Vieron el 90 % o más",
    "byViewer": "Por alumno",
    "bySession": "Sesiones",
    "viewer": "Alumno",
    "sessions": "Sesiones",
    "coverage": "Visto",
    "watched": "Tiempo",
    "lastSeen": "Último acceso",
    "startedAt": "Inicio",
    "device": "Navegador y dispositivo",
    "location": "Ubicación",
    "endReason": "Cierre",
    "empty": "Todavía no hay visualizaciones.",
    "valuesTitle": "Costos y uso en el período"
  },
  "endReason": {
    "ACTIVE": "Viendo",
    "ENDED": "Salió de la clase",
    "EXPIRED": "Inactiva",
    "REPLACED": "Abierta en otro lugar"
  },
  "reupload": {
    "title": "Volver a subir el archivo",
    "description": "Sube el archivo de nuevo para este mismo video. Las clases que ya lo usan siguen vinculadas."
  },
  "usage": {
    "title": "Uso de video",
    "month": "Mes",
    "storage": "Almacenamiento",
    "storageHint_one": "{{count}} video",
    "storageHint_zero": "{{count}} videos",
    "storageHint_other": "{{count}} videos",
    "processed": "Procesado en el período",
    "processedHint": "Salida: SD {{sd}} · HD {{hd}} · 4K {{uhd}} min",
    "watched": "Visto en el período",
    "watchedHint": "$t(adminVideos:sessionsCount, {\"count\": {{sessions}} }) · $t(adminVideos:viewersCount, {\"count\": {{viewers}} }) · {{data}} descargados",
    "gb": "{{value}} GB",
    "minutes": "{{value}} min",
    "cost": "Costo estimado",
    "costHint": "Almacenamiento {{storage}} · Procesamiento {{processing}} · Entrega {{delivery}}"
  },
  "tenantUsage": {
    "title": "Uso de video por escuela",
    "subtitle": "Volumen de video por escuela en el período y el costo real de Google Cloud.",
    "loadError": "No se pudo cargar el uso.",
    "empty": "No se encontraron escuelas.",
    "name": "Escuela",
    "videos": "Videos",
    "storage": "Almacenamiento (GB)",
    "processed": "Procesados (min)",
    "watched": "Vistos (min)",
    "costStorage": "Almacenamiento",
    "costProcessing": "Procesamiento",
    "costDelivery": "Entrega",
    "costTotal": "Total",
    "grandTotal": "Total general",
    "platform": "Plataforma (no asignado)"
  },
  "failure": {
    "FILE_TOO_LARGE": "el archivo supera el límite de 20 GB.",
    "NO_VIDEO_STREAM": "el archivo no tiene una pista de video válida.",
    "VIDEO_TOO_SHORT": "el video debe durar al menos 5 segundos.",
    "PROBE_FAILED": "no se pudo leer el archivo. Puede estar dañado o en un formato no compatible."
  },
  "watermarkText": {
    "NONE": "Ninguno",
    "USER_EMAIL": "Correo del usuario",
    "TENANT_NAME": "Nombre de la escuela",
    "VIDEO_ID": "Código del video",
    "CUSTOM": "Personalizado"
  },
  "watermarkPosition": {
    "TOP_RIGHT": "Superior derecha",
    "BOTTOM_RIGHT": "Inferior derecha",
    "BOTTOM_LEFT": "Inferior izquierda",
    "TOP_LEFT": "Superior izquierda",
    "FLOATING": "Flotante"
  },
  "library": {
    "tabs": {
      "videos": "Videos",
      "viewers": "Alumnos y costos"
    },
    "searchPlaceholder": "Buscar por título",
    "statusFilter": "Filtrar por estado",
    "allStatuses": "Todos los estados",
    "noResults": "Ningún video coincide con esta búsqueda.",
    "columns": {
      "video": "Video",
      "visibility": "Visibilidad",
      "date": "Fecha",
      "views": "Visualizaciones",
      "watchTime": "Tiempo visto",
      "subtitles": "Subtítulos",
      "data": "Datos descargados",
      "storage": "Almacenamiento",
      "cost": "Costo"
    },
    "selectAll": "Seleccionar todos los videos de la página",
    "selectOne": "Seleccionar {{title}}",
    "selected_one": "{{count}} seleccionado",
    "selected_zero": "{{count}} seleccionados",
    "selected_other": "{{count}} seleccionados",
    "clearSelection": "Limpiar selección",
    "bulkVisibility": "Cambiar visibilidad",
    "bulkDelete": "Eliminar",
    "bulkDeleteTitle": "¿Eliminar los videos seleccionados?",
    "bulkDeleteDescription_one": "Se eliminará el video seleccionado. Las clases que lo usan dejarán de reproducirse.",
    "bulkDeleteDescription_zero": "Se eliminarán los {{count}} videos seleccionados. Las clases que los usan dejarán de reproducirse.",
    "bulkDeleteDescription_other": "Se eliminarán los {{count}} videos seleccionados. Las clases que los usan dejarán de reproducirse.",
    "bulkUpdated": "Visibilidad actualizada.",
    "bulkDeleted": "Videos eliminados.",
    "bulkPartial": "No se pudieron modificar {{failed}} de {{total}} videos.",
    "openStudio": "Abrir {{title}} en el estudio",
    "delete": "Eliminar {{title}}",
    "subtitleCount_one": "{{count}} idioma",
    "subtitleCount_zero": "{{count}} idiomas",
    "subtitleCount_other": "{{count}} idiomas",
    "noSubtitles": "Sin subtítulos",
    "details": {
      "expand": "Ver métricas de {{title}}",
      "collapse": "Ocultar métricas de {{title}}",
      "cost": "Costo en el período",
      "watchedHint": "$t(adminVideos:sessionsCount, {\"count\": {{sessions}} }) · $t(adminVideos:viewersCount, {\"count\": {{viewers}} }) · {{data}} descargados",
      "costBreakdown": "Entrega {{delivery}} · Almacenamiento {{storage}} · Procesamiento {{processing}}"
    }
  },
  "viewersPage": {
    "title": "Alumnos y costos",
    "subtitle": "Mira qué vio cada alumno, cuánto de cada video ya vio y cuánto costó y se cobrará en el período.",
    "month": "Mes",
    "search": "Buscar alumno por nombre o correo",
    "loading": "Cargando alumnos...",
    "loadError": "No se pudo cargar el uso por alumno.",
    "empty": "Ningún alumno vio videos en este período.",
    "noMatch": "Ningún alumno coincide con esta búsqueda.",
    "totals": {
      "viewers": "Alumnos",
      "watched": "Tiempo visto",
      "cost": "Costo total",
      "charge": "A cobrar",
      "chargeHint": "Margen aplicado: {{percent}}%"
    },
    "columns": {
      "student": "Alumno",
      "videos": "Videos",
      "watched": "Tiempo visto",
      "cost": "Costo de entrega",
      "charge": "A cobrar",
      "lastSeen": "Última vez",
      "progress": "Progreso",
      "sessions": "Sesiones",
      "data": "Datos descargados"
    },
    "anonymous": "Acceso público (sin sesión)",
    "removedVideo": "Video eliminado",
    "expand": "Ver videos de {{name}}",
    "collapse": "Ocultar videos de {{name}}",
    "exportCsv": "Exportar CSV",
    "csv": {
      "student": "Alumno",
      "email": "Correo",
      "video": "Video",
      "watchedSeconds": "Segundos vistos",
      "progress": "Progreso (%)",
      "cost": "Costo de entrega (USD)",
      "charge": "A cobrar (USD)",
      "data": "Datos descargados (GB)"
    },
    "note": "Por alumno mostramos solo la entrega. El costo es el real de Google Cloud, repartido según lo que descargó cada alumno; donde aparece \"—\", Google Cloud aún no informó el costo de ese período. El almacenamiento y el procesamiento son costos del curso y están en el costo total. El valor no incluye ganancia.",
    "estimated": "Parte estimada: el navegador del alumno no informó el consumo."
  },
  "dateRange": {
    "from": "Desde",
    "to": "Hasta",
    "placeholder": "DD/MM/AAAA",
    "order": "La fecha inicial no puede ser posterior a la final.",
    "presets": {
      "thisMonth": "Este mes",
      "lastMonth": "Mes pasado",
      "last30": "Últimos 30 días"
    }
  },
  "picker": {
    "tabs": {
      "upload": "Subir nuevo",
      "existing": "Usar existente"
    },
    "search": "Buscar video por título",
    "empty": "Aún no tienes videos listos. Sube uno nuevo.",
    "select": "Usar el video {{title}}",
    "views_one": "{{count}} visualización",
    "views_zero": "{{count}} visualizaciones",
    "views_other": "{{count}} visualizaciones",
    "usedIn_one": "Usado en {{count}} clase",
    "usedIn_zero": "Usado en {{count}} clases",
    "usedIn_other": "Usado en {{count}} clases",
    "unused": "Aún sin clases"
  },
  "costs": {
    "title": "Costos",
    "provisional": "Provisional",
    "refresh": "Actualizar ahora",
    "synced": "Costos actualizados.",
    "asOf": "Datos reales de Google Cloud hasta {{date}}",
    "categories": {
      "delivery": "Entrega (CDN)",
      "storage": "Almacenamiento",
      "processing": "Procesamiento"
    },
    "real": "Real",
    "pending": "Esperando datos reales de Google Cloud.",
    "partial": "Parte del período aún sin datos reales de Google Cloud."
  },
  "studioTabs": {
    "settings": "Configuración",
    "analytics": "Analytics"
  }
}
